import { ProductsLeaderboardTabsProps, ProductsOverviewTabProps, ProductsTrendsTabProps } from '@models/SavedViews';

export const restoreProductsOverviewTabViewState = (props: ProductsOverviewTabProps) => {
  const { overviewShareVsValueVolumeFilterType, setOverviewShareVsValueVolumeFilterType } = props;
  if (overviewShareVsValueVolumeFilterType) {
    setOverviewShareVsValueVolumeFilterType(overviewShareVsValueVolumeFilterType);
  }
};

export const restoreProductsTrendsTabViewState = (props: ProductsTrendsTabProps) => {
  const {
    trendsSelectedKpi,
    setTrendsSelectedKpi,
    trendsSelectedFocusArea,
    setTrendsSelectedFocusArea,
    trendsSelectedSaleType,
    setTrendsSelectedSaleType,
    trendsSetSelectedLineChartSaleType,
    setTrendsSetSelectedLineChartSaleType,
    trendsSelectedRetailerOption,
    setTrendsSelectedRetailerOption,
  } = props;

  if (trendsSelectedKpi) {
    setTrendsSelectedKpi(trendsSelectedKpi);
  }

  if (trendsSelectedFocusArea) {
    setTrendsSelectedFocusArea(trendsSelectedFocusArea);
  }

  if (trendsSelectedSaleType) {
    setTrendsSelectedSaleType(trendsSelectedSaleType);
  }

  if (trendsSetSelectedLineChartSaleType) {
    setTrendsSetSelectedLineChartSaleType(trendsSetSelectedLineChartSaleType);
  }

  if (trendsSelectedRetailerOption) {
    setTrendsSelectedRetailerOption(trendsSelectedRetailerOption);
  }
};

export const restoreProductsLeaderboardTabViewState = (props: ProductsLeaderboardTabsProps) => {
  const {
    leaderboardIsTableView,
    setLeaderboardIsTableView,
    leaderboardSelectedDisplayType,
    setLeaderboardSelectedDisplayType,
    leaderboardSelectedSaleType,
    setLeaderboardSelectedSaleType,
    leaderboardSelectedSortingOption,
    setLeaderboardSelectedSortingOption,
    sorting,
    setSortingOptionsProducts,
    growthOption,
    setGrowthOption,
  } = props;

  setLeaderboardIsTableView(leaderboardIsTableView!);

  if (leaderboardSelectedDisplayType) {
    setLeaderboardSelectedDisplayType(leaderboardSelectedDisplayType);
  }

  if (leaderboardSelectedSaleType) {
    setLeaderboardSelectedSaleType(leaderboardSelectedSaleType);
  }

  if (leaderboardSelectedSortingOption) {
    setLeaderboardSelectedSortingOption(leaderboardSelectedSortingOption);
  }

  if (sorting) {
    setSortingOptionsProducts(sorting);
  }

  if (growthOption) {
    setGrowthOption(growthOption);
  }
};
